//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import DateTime from 'vue-date-time-m'
    export default{
        name:'medicine_commissioned',
        components: {
            DateTime
        },
        data(){
            return{
                options:['雅培金装喜康宝（母乳营养补充剂）','鱼腥草滴眼液','布拉氏酵母菌','茵栀黄口服液','伊可新维生素AD滴剂胶囊型','左氧佛沙星滴眼液','Baby Ddrops婴儿维生素d3滴剂','小儿伪麻美芬滴剂（艾畅）','鲁米那','枯草杆菌二联活菌散','肝泰乐'],
                form:{
                    room_number:'',
                    maternal_name:'',
                    entrust_man:'',
                    drug_matter:[
                        {
                            drug_name:'',
                            use_method:'',
                            take_dost:''
                        },{
                            drug_name:'',
                            use_method:'',
                            take_dost:''
                        },{
                            drug_name:'',
                            use_method:'',
                            take_dost:''
                        },{
                            drug_name:'',
                            use_method:'',
                            take_dost:''
                        },{
                            drug_name:'',
                            use_method:'',
                            take_dost:''
                        }
                    ],
                    family_sign:'',
                    nurse_sign:[
                        {
                            sign_show:false,
                            src:''
                        },{
                            sign_show:false,
                            src:''
                        },{
                            sign_show:false,
                            src:''
                        },{
                            sign_show:false,
                            src:''
                        }
                    ],
                    group_nurse_sign:'',
                    nurse_long_sign:''
                },
                family_sign_show:false,
                group_nurse_sign_show:false,
                nurse_long_sign_show:false,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
                get_host:host.host
            }
        },
        created(){
            // this.get_baby_list()
            if(this.$route.query.list_id){
                this.apiDetail()
            }else{
                this.apiMemberInfo()
            }
        },
        methods:{
            //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.room_number = res.data.room_name
                        this.form.maternal_name = res.data.name
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 家属签名操作
            family_sign_save(){
                let signature ='family_sign_signature'
                const sigRef = this.$refs[signature]
                const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
                if (!comp || !comp.save) return
                let png = comp.save()
                this.form.family_sign = encodeURI(png)
                this.family_sign_show = true
            },
            family_sign_edit(){
                this.family_sign_show = false
                this.form.family_sign = ''
            },
            family_sign_clear(){
                let signature ='family_sign_signature'
                const sigRef = this.$refs[signature]
                if (Array.isArray(sigRef)) {
                    sigRef.forEach(c => c && c.clear && c.clear())
                } else if (sigRef && sigRef.clear) {
                    sigRef.clear()
                }
                this.form.family_sign = ''
            },
            //责任护士签名操作
            nurse_sign_save(index){              
                let signature ='nurse_sign_signature_'+index
                console.log(this.$refs)
                let png = this.$refs[signature][0].save()
                this.form.nurse_sign[index].src = encodeURI(png)
                this.form.nurse_sign[index].sign_show = true
            },
            nurse_sign_edit(index){
                this.form.nurse_sign[index].sign_show = false
                this.form.nurse_sign[index].src = ''
            },
            nurse_sign_clear(index){
                let signature ='nurse_sign_signature_'+index
                let refs = this.$refs[signature][0].clear()
                this.form.nurse_sign[index].src = ''
            },
            // 护士组长签名操作
            group_nurse_sign_save(){
                let signature ='group_nurse_sign_signature'
                const sigRef = this.$refs[signature]
                const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
                if (!comp || !comp.save) return
                let png = comp.save()
                this.form.group_nurse_sign = encodeURI(png)
                this.group_nurse_sign_show = true
            },
            group_nurse_sign_edit(){
                this.group_nurse_sign_show = false
                this.form.group_nurse_sign = ''
            },
            group_nurse_sign_clear(){
                let signature ='group_nurse_sign_signature'
                const sigRef = this.$refs[signature]
                if (Array.isArray(sigRef)) {
                    sigRef.forEach(c => c && c.clear && c.clear())
                } else if (sigRef && sigRef.clear) {
                    sigRef.clear()
                }
                this.form.group_nurse_sign = ''
            },
            // 护士长签名操作
            nurse_long_sign_save(){
                let signature ='nurse_long_sign_signature'
                const sigRef = this.$refs[signature]
                const comp = Array.isArray(sigRef) ? sigRef[sigRef.length - 1] : sigRef
                if (!comp || !comp.save) return
                let png = comp.save()
                this.form.nurse_long_sign = encodeURI(png)
                this.nurse_long_sign_show = true
            },
            nurse_long_sign_edit(){
                this.nurse_long_sign_show = false
                this.form.nurse_long_sign = ''
            },
            nurse_long_sign_clear(){
                let signature ='nurse_long_sign_signature'
                const sigRef = this.$refs[signature]
                if (Array.isArray(sigRef)) {
                    sigRef.forEach(c => c && c.clear && c.clear())
                } else if (sigRef && sigRef.clear) {
                    sigRef.clear()
                }
                this.form.nurse_long_sign = ''
            },
            //请求详情数据
            apiDetail(){
                let params = {
                    token: this.$cookie.get('token'),
                    id:this.$route.query.list_id
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.checkRoomApi.detailFeedDrugEntrustDetail(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        let data = res.data
                        let nurse_sign = []
                        if(data.nurse_sign.length == 0) {
                            nurse_sign = [
                                {
                                   sign_show:false,
                                    src:''
                                },{
                                   sign_show:false,
                                    src:''
                                },{
                                   sign_show:false,
                                    src:''
                                },{
                                   sign_show:false,
                                    src:''
                                }
                            ]
                        }
                        for(let item of data.nurse_sign){
                            let obj = {
                                sign_show:item== ''  ? false : true,
                                src:item.indexOf(this.get_host) != -1 ? item : this.get_host+item
                            }
                            nurse_sign.push(obj)
                        }
                        this.form.room_number = data.room_number
                        this.form.maternal_name = data.maternal_name
                        this.form.entrust_man = data.entrust_man
                        this.form.drug_matter = data.drug_matter
                        this.form.entrust_time = data.entrust_time
                        this.family_sign_show = data.family_sign == '' ? false : true
                        this.form.family_sign = data.family_sign.indexOf(this.get_host) != -1 ? data.family_sign : this.get_host+data.family_sign
                        this.form.nurse_sign = nurse_sign
                        if(data.group_nurse_sign == ''){
                            this.group_nurse_sign_show = false
                            this.form.group_nurse_sign = ''
                        }else{
                            this.group_nurse_sign_show = true
                            this.form.group_nurse_sign = data.group_nurse_sign.indexOf(this.get_host) != -1 ? data.group_nurse_sign : this.get_host+data.group_nurse_sign
                        }
                        if(data.nurse_long_sign == ''){
                            this.nurse_long_sign_show = false
                            this.form.nurse_long_sign = ''
                        }else{
                            this.nurse_long_sign_show = true
                            this.form.nurse_long_sign = data.nurse_long_sign.indexOf(this.get_host) != -1 ? data.nurse_long_sign : this.get_host+data.nurse_long_sign
                        }
                        this.$vux.loading.hide()
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //请求添加数据
            apiAddForm(){
                let nurse_sign = []
                if(this.form.nurse_sign.length){
                    for(let item of this.form.nurse_sign){
                        nurse_sign.push(item.src)
                    }
                }
                let params = {
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    room_number:this.form.room_number,
                    maternal_name:this.form.maternal_name,
                    entrust_man:this.form.entrust_man,
                    drug_matter:this.form.drug_matter,
                    entrust_time:this.form.entrust_time,
                    family_sign:this.form.family_sign,
                    nurse_sign:nurse_sign,
                    group_nurse_sign:this.form.group_nurse_sign,
                    nurse_long_sign:this.form.nurse_long_sign,           
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.checkRoomApi.addFeedDrugEntrust(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'medicine_commissioned',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            // 请求更新数据
            apiUpdateForm(){
                let nurse_sign = []
                if(this.form.nurse_sign.length){
                    for(let item of this.form.nurse_sign){
                        nurse_sign.push(item.src.indexOf(this.get_host) != -1 ? item.src.replace(this.get_host,'') : item.src,)
                    }
                }
                let params = {
                    token: this.$cookie.get('token'),
                    member_id:this.$cookie.get('id'),
                    maternal_info_id: this.$route.query.id,
                    room_number:this.form.room_number,
                    maternal_name:this.form.maternal_name,
                    entrust_man:this.form.entrust_man,
                    drug_matter:this.form.drug_matter,
                    entrust_time:this.form.entrust_time,
                    family_sign:this.form.family_sign.indexOf(this.get_host) != -1 ? this.form.family_sign.replace(this.get_host,'') : this.form.family_sign,
                    nurse_sign:nurse_sign,
                    group_nurse_sign:this.form.group_nurse_sign.indexOf(this.get_host) != -1 ? this.form.group_nurse_sign.replace(this.get_host,'') : this.form.group_nurse_sign,
                    nurse_long_sign:this.form.nurse_long_sign.indexOf(this.get_host) != -1 ? this.form.nurse_long_sign.replace(this.get_host,'') : this.form.nurse_long_sign,
                    id:this.$route.query.list_id,           
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.checkRoomApi.updateFeedDrugEntrust(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 200){
                        this.$vux.loading.hide()
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal:this.$route.query.tabVal,
                                name : 'medicine_commissioned',
                            }
                        })
                    }else{
                        this.$vux.loading.hide()
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            submitForm(){
                if(this.$route.query.list_id){
                    console.info("请求更新数据")
                    this.apiUpdateForm()
                }else{
                    console.info("请求添加数据")
                    this.apiAddForm()
                }
            }
        }
    }



// WEBPACK FOOTER //
// ./src/components/medicine_commissioned.vue